import { autoserialize, inheritSerialization } from 'cerialize';
import { SignatureRequest } from './signature-request';

@inheritSerialization(SignatureRequest)
export class SignatureRequestDetail extends SignatureRequest {
  @autoserialize
  status: string;

  @autoserialize
  reviewedBy: string;
}
